<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <!-- Model selector -->
          <div slot="header">
            <h5 style="display: inline" class="card-title mb-0 text-center">
              Choose Model
            </h5>
            <b-form-input
              style="display: inline-block; width: 250px; float: right"
              v-model="searchQuery"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
          </div>
          <!-- Model selector END -->

          <b-row style="margin-bottom: 15px">
            <b-button-group size="lg" class="mybtns">
              <b-button
                v-for="(btn, idx) in buttons"
                style="
                  margin: 2px;
                  border-radius: 0 !important;
                  box-shadow: 2px 2px black;
                  font-weight: 600;
                "
                :key="idx"
                @click="changeView(btn.caption)"
                variant="primary"
              >
                {{ btn.caption }}
              </b-button>
            </b-button-group>
          </b-row>

          <b-row>
            <!-- Loading selector -->
            <div
              style="height: 400px; padding-top: 150px"
              v-if="loadingData"
              class="loading"
            >
              <b-row>
                <b-col lg="12">
                  <div class="sk-double-bounce">
                    <div class="sk-child sk-double-bounce1"></div>
                    <div class="sk-child sk-double-bounce2"></div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <!-- Loading selector END -->

            <!-- Models List -->
            <template v-else>
              <template v-for="model in filterItems(models)">
                <b-col lg="3" sm="6" :key="model.fns_part" style="padding: 5px">
                  <a
                    class="locationLabels"
                    :href="'#/model/?part=' + model.fns_part"
                    >{{ model.model }}
                    <span v-if="model.backlog != 0" style="color: yellow">{{
                      model.backlog
                    }}</span></a
                  >
                </b-col>
              </template>
            </template>
            <!-- Models List END -->
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      buttons: [
        { caption: "Fiber Gear" },
        { caption: "Line Gear" },
        { caption: "Power Supply" },
        { caption: "Transponder" },
        { caption: "Meter" },
        { caption: "Headend" },
      ],
      title: "",
      models: [],
      searchQuery: "",
      loadingData: false,
    };
  },
  methods: {
    changeView(value) {
      this.loadingData = true;
      this.title = value;
      let params = {};
      params = {
        type: value,
      };
      this.$http
        .get("api/" + this.$company + "/products/modelsByGroup.php", { params })
        .then(
          (res) => {
            console.log(res.data);
            this.models = res.data;
            this.loadingData = false;
          },
          (err) => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },
    filterItems: function (models) {
      var app = this;
      return models.filter(function (models) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return models.model.match(regex);
      });
    },
  },
  mounted() {
    this.changeView("Power Supply");
  },
};
</script>

<style>
.mybtns {
  display: block !important;
  margin: auto;
}
.locationLabels {
  padding: 9px;
}
.loading {
  display: block !important;
  margin: auto !important;
}
</style>
